import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EfektikaPdfDownloadService } from 'src/app/services/efektika-pdf-download';

@Component({
  selector: 'libero-client-accept-efektika-draft-strategy-modal',
  templateUrl: './client-accept-efektika-draft-strategy-modal.component.html',
  styleUrl: './client-accept-efektika-draft-strategy-modal.component.scss',
  standalone: false,
})
export class ClientAcceptEfektikaDraftStrategyModalComponent {
  @Input() public show: boolean | null = null;
  @Output() public continueBtnClick = new EventEmitter<void>();
  @Output() public backBtnClick = new EventEmitter<void>();
  @Input() public loadingConfirm: boolean | null  = false;

  public constructor(
    public efektikaPdfDownloadService: EfektikaPdfDownloadService,
  ) {}

  public onContinueBtnClick(): void {
    if (!this.loadingConfirm) {
      this.loadingConfirm = true;
      this.continueBtnClick.emit();
    }
  }

  public onBackBtnClick(): void {
    this.backBtnClick.emit();
  }
}
